var _circle, _path, _path2, _circle2, _circle3, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "#40586B",
    stroke: "#DCE3ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1851 17.8888H14.6296C13.1568 17.8888 11.9629 19.0827 11.9629 20.5555V27.5751L11.9629 32.111C11.9629 33.5838 13.1568 34.7777 14.6296 34.7777H23.074H31.5184C32.9912 34.7777 34.1851 33.5838 34.1851 32.111V26.7777",
    stroke: "white",
    strokeWidth: 2.06933,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9629 22.7778H19.074C21.0377 22.7778 22.6296 24.3697 22.6296 26.3334V26.3334C22.6296 28.2971 21.0377 29.8889 19.074 29.8889H11.9629V22.7778Z",
    stroke: "white",
    strokeWidth: 2.06933,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6296,
    cy: 26.3333,
    r: 0.888889,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.888889
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1853,
    cy: 18.7778,
    r: 5.33333,
    stroke: "white",
    strokeWidth: 2.06933,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1852 17L34.1852 20.5556",
    stroke: "white",
    strokeWidth: 2.06933,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9629 18.7778L32.4073 18.7778",
    stroke: "white",
    strokeWidth: 2.06933,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunding);
export default __webpack_public_path__ + "static/media/Funding.ffd0774d17b26289300d89abbcc51438.svg";
export { ForwardRef as ReactComponent };